import React, { Suspense } from 'react';
import Sidebar from './Sidebar';
import {Button} from "../../../components/buttons";

const Docs = ({type,children,location}) => {
    return (
        <div className="dashboard-content">
            <div className="container-fluid" id="wrapper">
                <div className="row">
                    <Sidebar location={location}/>
                    <main role="main" className="col-9 offset-3 px-0">

                        <div className="row justify-content-end px-5">
                            <Button
                                onClick={() => window.location.assign('https://dashboard.biteship.com/signin')}
                                className="mr-4 btn btn-outline-primary border-0"
                            >
                                Masuk
                            </Button>
                            <Button
                                onClick={() => window.location.assign('https://dashboard.biteship.com/signup')}
                                className=" text-primary btn btn-primary text-white"
                            >
                                Daftar
                            </Button>
                        </div>

                        <section className="mt-4 bg-lighter">
                            <div className="container">
                                <div className="px-4">
                                    {children}
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>
        </div>
    )
}

export default Docs;
